module.exports = __webpack_public_path__ + "img/9791156759195.39fec1d8.jpg";